(() => {
  if (window.BsoKitLanding) return;
  const roots = new WeakMap();
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const visible = el => el && el.getBoundingClientRect().width > 0 && el.getBoundingClientRect().height > 0;
  function findProduct(root) {
    const custom = root.dataset.productTarget;
    if (custom) {
      try { const el = document.querySelector(custom); if (visible(el)) return el; } catch (_) {}
      const el = document.getElementById(custom.replace(/^#/, ''));
      if (visible(el)) return el;
    }
    for (const selector of ['[id^="ProductInfo-"]', '.product__info-wrapper', 'product-info', '[id^="ProductForm-"]', 'form[action*="/cart/add"]']) {
      const match = [...document.querySelectorAll(selector)].find(el => !root.contains(el) && visible(el));
      if (match) return match;
    }
    return null;
  }
  function init(root) {
    if (roots.has(root)) return;
    const controller = new AbortController();
    const signal = controller.signal;
    const cleanup = [];
    roots.set(root, { controller, cleanup });
    root.addEventListener('click', event => {
      const link = event.target.closest('[data-bso-kit-cta]');
      if (!link) return;
      const target = findProduct(root);
      if (!target) return;
      event.preventDefault();
      const header = document.querySelector('sticky-header, .shopify-section-header-sticky, #shopify-section-header');
      const offset = Math.min(header?.getBoundingClientRect().height || 0, 160) + 24;
      window.scrollTo({ top: Math.max(0, target.getBoundingClientRect().top + window.scrollY - offset), behavior: reduced() ? 'auto' : 'smooth' });
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    }, { signal });
    for (const carousel of root.querySelectorAll('[data-bso-kit-carousel]')) {
      const track = carousel.querySelector('[data-bso-kit-track]');
      const slides = [...track.children];
      if (!slides.length) { carousel.hidden = true; continue; }
      const dots = [...carousel.querySelectorAll('[data-bso-kit-dot]')];
      let index = 0;
      const update = () => {
        const left = track.getBoundingClientRect().left;
        index = slides.reduce((best, card, i) => Math.abs(card.getBoundingClientRect().left - left) < Math.abs(slides[best].getBoundingClientRect().left - left) ? i : best, 0);
        dots.forEach((dot, i) => { dot.setAttribute('aria-current', String(i === index)); });
      };
      const go = i => {
        const wanted = slides[(i + slides.length) % slides.length];
        track.scrollTo({ left: track.scrollLeft + wanted.getBoundingClientRect().left - track.getBoundingClientRect().left, behavior: reduced() ? 'instant' : 'smooth' });
      };
      const move = direction => {
        const max = track.scrollWidth - track.clientWidth;
        const step = slides[0].getBoundingClientRect().width + 22;
        const atEnd = track.scrollLeft >= max - 2;
        const atStart = track.scrollLeft <= 2;
        track.scrollTo({left: direction > 0 ? (atEnd ? 0 : Math.min(max, track.scrollLeft + step)) : (atStart ? max : Math.max(0, track.scrollLeft - step)), behavior: reduced() ? 'instant' : 'smooth'});
      };
      carousel.querySelector('[data-bso-kit-prev]')?.addEventListener('click', () => move(-1), { signal });
      carousel.querySelector('[data-bso-kit-next]')?.addEventListener('click', () => move(1), { signal });
      dots.forEach((dot, i) => dot.addEventListener('click', () => go(i), { signal }));
      track.addEventListener('scroll', update, { passive: true, signal });
      track.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, { signal });
      update();
    }
    for (const button of root.querySelectorAll('[data-bso-kit-pause]')) {
      button.addEventListener('click', () => {
        const paused = root.classList.toggle('bso-kit-motion-paused');
        button.setAttribute('aria-pressed', String(paused));
        button.textContent = paused ? button.dataset.play : button.dataset.pause;
      }, { signal });
    }
    const timer = root.querySelector('[data-bso-kit-timer]');
    if (timer) {
      const end = Date.parse(root.dataset.saleEnd || '');
      if (Number.isFinite(end)) {
        const tick = () => {
          const remaining = Math.max(0, Math.floor((end - Date.now()) / 1000));
          const values = [Math.floor(remaining / 3600), Math.floor(remaining / 60) % 60, remaining % 60];
          timer.querySelectorAll('[data-bso-kit-number]').forEach((node, i) => { node.textContent = String(values[i]).padStart(2, '0'); });
          timer.hidden = remaining === 0;
          const ended = root.querySelector('[data-bso-kit-ended]');
          if (ended) ended.hidden = remaining > 0;
          if (!remaining) root.dataset.saleExpired = 'true';
        };
        tick(); const interval = setInterval(tick, 1000); cleanup.push(() => clearInterval(interval));
      } else { timer.hidden = true; }
    }
    const sticky = root.querySelector('[data-bso-kit-sticky]');
    if (sticky) {
      const updateSticky = () => {
        const target = findProduct(root);
        const rect = target?.getBoundingClientRect();
        const inView = rect && rect.bottom > 120 && rect.top < window.innerHeight - 100;
        sticky.hidden = !target || window.scrollY < 400 || !!inView;
      };
      window.addEventListener('scroll', updateSticky, { passive: true, signal });
      window.addEventListener('resize', updateSticky, { passive: true, signal });
      updateSticky();
    }
  }
  const scan = scope => {
    if (scope.matches?.('[data-bso-kit-root]')) init(scope);
    scope.querySelectorAll('[data-bso-kit-root]').forEach(init);
  };
  window.BsoKitLanding = { scan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  else scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    const all = [...event.target.querySelectorAll('[data-bso-kit-root]')];
    if (event.target.matches('[data-bso-kit-root]')) all.push(event.target);
    all.forEach(root => { const state = roots.get(root); state?.controller.abort(); state?.cleanup.forEach(fn => fn()); roots.delete(root); });
  });
})();
